import AppMain from "./components/AppMain";
import sidebar from "./components/sidebar/index.vue";
import navbar from "./components/navbar/index.vue";
import AppLink from '@/components/common/link';
import Vue from "vue"; 

import {
    Container,
    Main,
    Aside,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Header,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Row,
    Col,
    Scrollbar,
    Avatar
} from "element-ui";

Vue.use(Container);
Vue.use(Main);
Vue.use(Aside);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Header);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Scrollbar);
Vue.use(Avatar);

const page = {
    name: "AppLayout",
    components: {
        AppMain,
        sidebar,
        navbar,
        AppLink
    },
    data() {
        return {
        }
    },
    mixins: [],
    computed: {
    },
    beforeCreate: function () {


    }
}
export default page


// WEBPACK FOOTER //
// ./src/layout/master/index.js